import {Component, ConfigOptions} from 'panel';
import {JsxVNode} from 'snabbdom-jsx-lite';

import {getCookie} from 'common/util/cookie';
import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {TwoFactorStep} from '../validation';
import {template} from './template';
import './index.styl';

/**
 * This interface represents the shape of the JSON responses that the /security/totp/
 * endpoint returns.
 */

export interface TotpState {
  showSecretModal: boolean;
  secret: string;
  formInputEmpty: boolean;
}

export class Totp extends Component<TotpState> {
  private form: HTMLFormElement;

  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      error: {type: `string`, description: `invalid code error message`},
      step: {type: `number`, description: `stage of verification process. Look at TwoFactorStep for more detail.`},
    };
  }

  get config(): ConfigOptions<TotpState> {
    return {
      template,
      defaultState: {showSecretModal: false, secret: ``, formInputEmpty: true},
      helpers: {
        onInsert: (node: JsxVNode): void => {
          this.form = node.elm as HTMLFormElement;
        },
        submitForm: (): void => {
          this.form.submit();
        },
        getCsrfToken: (): string => {
          return getCookie(`csrftoken`);
        },
        handleClickBackButton: (): void => {
          if (this.attr(`step`) === TwoFactorStep.Verify) {
            window.location.assign(`/login`);
          } else {
            window.location.assign(`/security/twofactor/setup`);
          }
        },
        setIsFormValueEmpty: (ev) => {
          if (ev.target.value.length > 0) {
            this.update({formInputEmpty: false});
          }
        },
      },
    };
  }
}

export const TotpEl = defineAndMakeJsxFactory(`mp-totp-two-factor`, Totp);
